// Sections grouped under the "Ari OS" navigation dropdown
export const platformSections = [
  {
    id: 'ari-os',
    label: 'On Device',
  },
  {
    id: 'chat',
    label: 'Web',
  },
  {
    id: 'cloud',
    label: 'Cloud',
  },
  {
    id: 'business',
    label: 'Business',
  },
  {
    id: 'mobile-app',
    label: 'Mobile App',
  },
]

// Sections tracked for the active-state indicator in the header
export const trackedSectionIds = [
  'home',
  'ari-os',
  'chat',
  'cloud',
  'business',
  'mobile-app',
  'architecture',
  'developers',
]

export const sectionColors: {
  [key: string]: string
} = {
  home: '#E9A165',
  'ari-os': '#E9A165',
  chat: '#D25796',
  cloud: '#8846DE',
  business: '#D25796',
  'mobile-app': '#8846DE',
  architecture: '#E9A165',
  developers: '#8846DE',
  pricing: '#D25796',
}
